import { Link } from "react-router-dom";
import { AppRoutes } from "@ugg/shared/routes/app-routes";
import { useDetectApp } from "lib/monoapp";

const AccountCreationLayout = ({ children }) => {
  const isApp = useDetectApp();
  return (
    <div className="w-full relative">
      <img
        src="https://static.bigbrain.gg/assets/lol/backgrounds/account-setup-bg.png"
        alt="Account Setup Background"
        className="hidden xs:block absolute inset-0 w-full h-screen object-cover z-0"
        style={{ pointerEvents: "none" }}
      />
      {!isApp && (
        <Link className="absolute top-[24px] left-[24px] z-50" to={AppRoutes.HOME}>
          <img className="w-[80px]" src="https://static.bigbrain.gg/assets/ugg/logo/ugg-logo.svg" alt="U.GG Logo" />
        </Link>
      )}
      <div className="w-full max-w-[300px] mx-auto flex flex-col items-center justify-center xs:px-0 relative">
        <div className="w-full max-w-[300px] mx-auto pt-[100px] relative z-10">{children}</div>
      </div>
    </div>
  );
};

export default AccountCreationLayout;
